import React from "react";

export const ServiceType = ({
  handleBlur,
  handleChange,
  values,
  errors,
  touched,
  setStep,
  setFieldValue,
  step,
}: {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  setFieldValue: any;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const isContinueDisabled = !values.accountType || errors.accountType;

  return (
    <div className="!border !border-gray-400 !py-4 !px-8 !rounded-[20px] !mb-8 !relative !bg-white">
      <p className="!font-semibold !text-gray-700 !mb-6">
        Choose Service Type{" "}
        {step > 0 && (
          <button
            onClick={() => {
              setStep(0);
            }}
            className=""
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 21L12 21H21"
                stroke="#36394A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2218 5.8279L15.0503 2.99947L20 7.94922L17.1716 10.7776M12.2218 5.8279L6.61522 11.4345C6.42769 11.622 6.32233 11.8764 6.32233 12.1416L6.32233 16.6771L10.8579 16.6771C11.1231 16.6771 11.3774 16.5718 11.565 16.3842L17.1716 10.7776M12.2218 5.8279L17.1716 10.7776"
                stroke="#36394A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        )}
      </p>
      <div className="!absolute !top-10 !right-6">
        {step > 0 && (
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2.5C6.5 2.5 2 7 2 12.5C2 18 6.5 22.5 12 22.5C17.5 22.5 22 18 22 12.5C22 7 17.5 2.5 12 2.5ZM10 17.5L5 12.5L6.41 11.09L10 14.67L17.59 7.08L19 8.5L10 17.5Z"
              fill="#287F6E"
            />
          </svg>
        )}
      </div>
      {step === 0 ? (
        <>
          <h2 className="!text-sm !text-gray-600 !mb-2">Account Type</h2>

          <div className="!grid !grid-cols-3 !gap-4">
            {/* WITHIN LAGOS */}
            <label className="flex !items-center !border !border-gray-100 !h-[50px] !px-5 !rounded-[10px] !cursor-pointer !relative">
              <div>
                <input
                  type="radio"
                  name="accountType"
                  value="WITHIN_LAGOS"
                  checked={values.accountType === "WITHIN_LAGOS"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="!absolute !opacity-0 !h-0 !w-0"
                />
                <div
                  className={`!absolute !top-3.5 !left-3 !h-5 !w-5 !rounded-full !border-2 ${
                    values.accountType === "WITHIN_LAGOS"
                      ? "!border-[#fe7f1f] !bg-[#fe7f1f]"
                      : "!border-gray-100"
                  }`}
                >
                  {values.accountType === "WITHIN_LAGOS" && (
                    <div className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2  !w-2 !h-2 !bg-white !rounded-full" />
                  )}
                </div>
              </div>
              <span className="!text-gray-500 !ml-5 !text-sm">
                Ship within Lagos
              </span>
            </label>

            {/* OUTSIDE LAGOS */}
            <label className="!flex !items-center !gap-3 !border !border-gray-100 !h-[50px] !px-5 !rounded-[10px] !cursor-pointer !relative">
              <div>
                <input
                  type="radio"
                  name="accountType"
                  value="OUTSIDE_LAGOS"
                  checked={values.accountType === "OUTSIDE_LAGOS"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="!absolute !opacity-0 !h-0 !w-0"
                />
                <div
                  className={`!absolute !top-3.5 !left-3 !h-5 !w-5 !rounded-full !border-2 ${
                    values.accountType === "OUTSIDE_LAGOS"
                      ? "!border-[#fe7f1f] !bg-[#fe7f1f]"
                      : "!border-gray-100"
                  }`}
                >
                  {values.accountType === "OUTSIDE_LAGOS" && (
                    <div className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2  !w-2 !h-2 !bg-white !rounded-full" />
                  )}
                </div>
              </div>
              <span className="!text-gray-500 !ml-2 !text-sm">
                Ship outside Lagos
              </span>
            </label>

            {/* OUTSIDE NIGERIA */}
            <label className="!flex !items-center !gap-3 !border !border-gray-100 !h-[50px] !px-5 !rounded-[10px] !cursor-pointer !relative">
              <div>
                <input
                  type="radio"
                  name="accountType"
                  value="OUTSIDE_NIGERIA"
                  checked={values.accountType === "OUTSIDE_NIGERIA"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="!absolute !opacity-0 !h-0 !w-0"
                />
                <div
                  className={`!absolute !top-3.5 !left-3 !h-5 !w-5 !rounded-full !border-2 ${
                    values.accountType === "OUTSIDE_NIGERIA"
                      ? "!border-[#fe7f1f] !bg-[#fe7f1f]"
                      : "border-gray-100"
                  }`}
                >
                  {values.accountType === "OUTSIDE_NIGERIA" && (
                    <div className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2  !w-2 !h-2 !bg-white !rounded-full" />
                  )}
                </div>
              </div>
              <span className="!text-gray-500 !ml-2 !text-sm">
                Ship outside Nigeria
              </span>
            </label>
          </div>

          {/* Validation Error */}
          {touched.accountType && errors.accountType ? (
            <div className="!flex !items-center !gap-1 !mt-1">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 4.83333V7.5M7 10.1667H7.00667M1 7.5C1 8.28793 1.15519 9.06815 1.45672 9.7961C1.75825 10.5241 2.20021 11.1855 2.75736 11.7426C3.31451 12.2998 3.97595 12.7417 4.7039 13.0433C5.43185 13.3448 6.21207 13.5 7 13.5C7.78793 13.5 8.56815 13.3448 9.2961 13.0433C10.0241 12.7417 10.6855 12.2998 11.2426 11.7426C11.7998 11.1855 12.2417 10.5241 12.5433 9.7961C12.8448 9.06815 13 8.28793 13 7.5C13 5.9087 12.3679 4.38258 11.2426 3.25736C10.1174 2.13214 8.5913 1.5 7 1.5C5.4087 1.5 3.88258 2.13214 2.75736 3.25736C1.63214 4.38258 1 5.9087 1 7.5Z"
                  stroke="#DF1C41"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className="text-red-500 text-sm">{errors.accountType}</div>
            </div>
          ) : null}

          <div className="!flex !justify-end !w-full !mt-6">
            <button
              type="button"
              onClick={() => {
                setStep(1);
                values.deliveries.map((delivery: any, index: number) => {
                  setFieldValue(`deliveries[${index}].d_schedule`, "");
                });
              }}
              disabled={isContinueDisabled}
              className={
                isContinueDisabled
                  ? "!opacity-50 !cursor-not-allowed !bg-gray-300  !rounded-lg !text-gray-700 !text-sm !py-2 !px-4"
                  : "!bg-[#fe7f1f]  !rounded-lg !text-white !text-sm !py-2 !px-4"
              }
            >
              Continue
            </button>
          </div>
        </>
      ) : (
        <h2 className="text-sm text-gray-600 mb-2">
          {values.accountType === "WITHIN_LAGOS"
            ? "Ship within lagos"
            : values.accountType === "OUTSIDE_LAGOS"
            ? "Ship outside lagos"
            : "Ship outside Nigeria"}
        </h2>
      )}
    </div>
  );
};
